module.exports = __webpack_public_path__ + "img/luxemburg-gare.9ebd370c.png";